/* @flow */
import AdminNewAutoMessageModal from './AdminNewAutoMessageModal.jsx';

export type AutoMessageOrg = $NonMaybeType<
  $ElementType<$ElementType<AdminNewAutoMessageOrgsQuery, 'organizations'>, number>
>;

export type AutoMessageContent = {
  body: string,
  __typename: 'AutoMessageContent',
};

export type AutoMessageSender = {
  avatarUrl: ?string,
  name: string,
  uuid: string,
  __typename: 'UserSender' | 'EntitySender',
};

export type AutoMessageSftpCredentials = {
  uuid: string,
  name: string,
  messages: *[],
  credentials: {
    username: string,
    password: string,
  },
};

export type AutoMessage = {
  sftpCredentials: ?AutoMessageSftpCredentials,
  messageName: ?string,
  orgUuid: ?string,
  csvName: ?string,
  uuid: string,
  status: AutoMessageStatus,
  sender: ?AutoMessageSender,
  includeParents: boolean,
  includeStudents: boolean,
  messageContent: ?AutoMessageContent,
  permissions: {
    canEdit: boolean,
  },
  isActivatable: boolean,
  previousSends?: ?{
    pageInfo: {
      hasNextPage: boolean,
    },
    edges: {
      node: {
        uuid: string,
        sentAt: any,
      },
      cursor: string,
    }[],
  },
};

export type AutoMessageTabKey = 'format-csv' | 'sync-data' | 'compose' | 'review';

export type AutoMessageTab = {
  tabKey: AutoMessageTabKey,
  name: string,
  component: React.Element<any>,
  nextStep: ?AutoMessageTabKey,
  prevStep: ?AutoMessageTabKey,
  isComplete: boolean,
};

export default AdminNewAutoMessageModal;
